import { useStyles } from './styles';
import { Box, Button } from '@mui/material';

function ButtonSelectBox({ title, options, value, onChange }) {
  const classes = useStyles();

  const handleClick = (optValue) => () => {
    onChange(optValue);
  };

  return (
    <Box mb={3}>
      <Box pb={2}>
        <span style={{ fontWeight: 600 }}>{title}</span>
      </Box>
      {options.map((opt, idx) => {
        const props = {
          variant: 'outlined',
        };

        if (value === opt.value) {
          props['color'] = 'primary';
        }

        return (
          <Box pb={1} key={`button-select-box-${idx}`}>
            <Button onClick={handleClick(opt.value)} {...props} sx={{ ...classes.button, ...classes.optButton }}>
              {opt.label}
            </Button>
          </Box>
        );
      })}
    </Box>
  );
}

export default ButtonSelectBox;
